/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect } from 'react';
import useContainerMeasurement from 'shared/hooks/useContainerMeasurement';

export const useTruncatedText = (
    textRef: React.RefObject<HTMLDivElement>,
    lines: number
) => {
    const containerWidth = useContainerMeasurement(textRef);
    const [{ textHeight, lineHeight }, setHeights] = useState({
        textHeight: 0,
        lineHeight: 0
    });
    const [isExpanded, setExpanded] = useState(false);

    const maxTextHeightBeforeTruncate = lines * lineHeight;
    const isTruncated = textHeight > maxTextHeightBeforeTruncate;

    const height =
        isExpanded || !isTruncated ? textHeight : maxTextHeightBeforeTruncate;

    useEffect(() => {
        const textElm = textRef.current as Element;

        if (!textElm) {
            return;
        }

        const { lineHeight } = window.getComputedStyle(textElm);
        const lineHeightPx = parseInt(lineHeight, 10);
        const textHeightPx = textElm.scrollHeight;

        setHeights({
            textHeight: textHeightPx,
            lineHeight: lineHeightPx
        });
    }, [containerWidth]);

    return {
        height,
        isTruncated,
        isExpanded,
        setExpanded
    };
};
